import { Document } from './document';
export class SaveDocumentRequest {
  document: Document;
  metaData: any;
}
